import get from 'lodash/get';
import { replace } from 'react-router-redux';
import { call, put, select } from 'redux-saga/effects';

import * as SpecialOffersActions from '../actions';
import * as SpecialOffersConstants from '../constants';
import * as D from '../deps';
import * as SpecialOffersProtectedUtils from '../protectedUtils';
import * as SpecialOffersSelectors from '../selectors';

import * as Helpers from './helpers';

const log = D.Logger.child({ component: 'src/domains/payments/specialOffers/sagas/workers' }, true);

export function* onEnterCodeRedemptionFlow({ payload: { code: specialOfferCode, isOfferPath } }) {
  const isListenerLoggedIn = yield select(D.Utils.Listener.isLoggedIn);
  const isAnonymousListener = yield select(D.Utils.Listener.isAnonymousListener);
  if (isListenerLoggedIn && isAnonymousListener) {
    yield call(Helpers.anonymousSpecialOfferRedemption, specialOfferCode);
    return;
  }

  if (isListenerLoggedIn && !isAnonymousListener) {
    yield call(Helpers.loggedInSpecialOfferRedemption, specialOfferCode);
    if (isOfferPath) {
      yield put(D.getInDomain('stats.actions.logEnterRedeemFlowForUrl')());
    }
    return;
  }

  // else, listener not logged in at all - should not be reachable, go to login as fail-safe
  log.error('logged out listener reached special offer redemption');
  yield put(replace(D.Utils.Route.getLoginPath()));
}

export function* onAcquireProductAttempt(action) {
  const specialOfferType = get(action, 'request.content.specialOfferType');
  if (specialOfferType === SpecialOffersConstants.OfferTypes.CODE_PRODUCT) {
    yield put(
      SpecialOffersActions.updateSpecialOfferRedemptionState({
        specialOfferStatus: SpecialOffersConstants.RedemptionStatus.ACQUIRING_PRODUCT,
      }),
    );
  }
}

export function* onAcquireProductSuccess() {
  const specialOfferStatus = yield select(SpecialOffersSelectors.getSpecialOfferStatus);
  if (specialOfferStatus) {
    yield put(SpecialOffersActions.resetSpecialOffer({ shouldResetCampaignCopy: false }));
  }
}

export function* onAcquireProductFail(action) {
  // @todo - WEBCLIENT-8964 - This is a temporary urgent fix to differentiate between listeners
  // payment backed and non-payment backed codes
  if (get(action, 'error.action.content.paymentProvider')) {
    return;
  }

  const specialOfferStatus = yield select(SpecialOffersSelectors.getSpecialOfferStatus);
  if (specialOfferStatus) {
    // we've failed acquiring the product after the promo code was successfully redeemed
    yield put(
      SpecialOffersActions.updateSpecialOfferRedemptionState({
        specialOfferStatus: SpecialOffersConstants.ErrorCodes.ACQUIRE_PRODUCT_FAILED,
      }),
    );
    yield put(replace(D.Utils.Route.getRedeemPath()));
  }
}

export function* onLogout() {
  yield put(SpecialOffersActions.resetSpecialOffer());
}

export function* onLocationChange(action) {
  const specialOfferStatus = yield select(SpecialOffersSelectors.getSpecialOfferStatus);
  const specialOfferProducts = yield select(SpecialOffersSelectors.getSpecialOfferProductGroups);
  if (specialOfferStatus || specialOfferProducts) {
    const pathname = get(action, 'payload.pathname');
    if (!SpecialOffersProtectedUtils.isPathInRedeemFlow(pathname)) {
      yield put(SpecialOffersActions.resetSpecialOffer());
    }
  }
}
